import { Card, Col, Row } from "antd";
import spacing from "../../../components/ui/spacingConfig";
import StatusBadges from "../../../components/tables/StatusBadges";
import { Action } from "../../../types/actions";
import dayjs from "dayjs";
import AttachmentPreview from "../../../components/ui/AttachmentPreview";

type Props = {
  actionData: Action | undefined;
  className?: string;
};

const CardDescription: React.FC<Props> = ({ actionData, className }) => {
  return (
    <Card title="Description" bordered={false} className={className}>
      <Row>
        <Col span={spacing.xxxs}>
          <p className="text-light-grey">Statut</p>
        </Col>
        <Col span={spacing.s}>
          <p>
            {actionData?.status ? (
              <StatusBadges value={actionData?.status} type="actions" />
            ) : (
              "Not found"
            )}
          </p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xxxs}>
          <p className="text-light-grey">Titre</p>
        </Col>
        <Col span={spacing.s}>
          <p>{actionData?.title}</p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xxxs}>
          <p className="text-light-grey">Description</p>
        </Col>
        <Col span={spacing.s}>
          <p className="text-small-size">{actionData?.description}</p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xxxs}>
          <p className="text-light-grey">Date d'Ã©chÃ©ance</p>
        </Col>
        <Col span={spacing.s}>
          <p>
            {actionData?.dateAsked
              ? dayjs(actionData.dateAsked).format("DD/MM/YYYY")
              : ""}
          </p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xxxs}>
          <p className="text-light-grey">AssignÃ©e Ã </p>
        </Col>
        <Col span={spacing.s}>
          {actionData?.performer ? (
            <p className="text-light-blue">{actionData?.performer.fullname}</p>
          ) : (
            "Not found"
          )}
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xxxs}>
          <p className="text-light-grey">PiÃ¨ces jointes</p>
        </Col>
        <Col span={spacing.s}>
          <div className="attachments-container">
            {actionData?.attachedFiles.map((file) => (
              <AttachmentPreview key={file.id} fileUrl={file.file} />
            ))}
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default CardDescription;
